import React from 'react';
import { ReadMoreText } from '../elements-buttons/read-more-text-toggle';
import ParkingTypes from './data/parkingTypes';
import { get, keyBy } from 'lodash';
import { FormattedMessage } from 'react-intl';

const ParkingInfo = ({ parkingInfo = {} }) => {
  const listingParkingTypes = (parkingInfo.types || [])
    .sort()
    .map(type => {
      const objTypes = keyBy(ParkingTypes, 'key');
      return get(objTypes, `[${type}].label`);
    });

  return (
    <div data-testing-id="parking-info">
      {
        parkingInfo.is_available
          ? (
            <div data-testing-id="parking-options">
              <ul className="flex flex-wrap list-style-inside no-gutter column-sm">
                {listingParkingTypes.map(parking => {
                  return <li className="flex-basis-33 parking-info-list" data-testing-id="parking-option">{parking}</li>;
                })}
              </ul>
              {
                parkingInfo.description
                  && (
                    <ReadMoreText
                      text={parkingInfo.description}
                      truncHeightPx={48}
                      bgColor="white"
                      unescapeText
                      readMoreFadeClass="variant"
                    />
                  )
              }
            </div>
          )
          : <p data-testing-id="no-parking-options">
            <FormattedMessage id='invite.parking_info.no_options' defaultMessage='There are no parking options at this space.' />
          </p>
      }
    </div>
  );
};

export default ParkingInfo;
